export enum ETags {
  USER_INFO = 'userInfo'
}
